import CreateBankAccountModal from './create_bank_account_modal';
export default CreateBankAccountModal;
